module.exports = __webpack_public_path__ + "static/media/sup_icons_lock-opened.63283e6b.svg";